import React, { Component } from 'react'

import {
    Spinner,
    GridCell,
    Button,
    Grid,
    Icon,
    css,
    Theme,
    TableGrid as Table,
    TCell as Cell,
    confirm,
} from "@bdfx/mergado-ui-kit"

import trans from 'trans'

import {
    superadminFillQueues,
    superadminGetProjectInfo,
    superadminCleanImagesCache,
    superadminUnlinkTemplatePNGCache,
    superadminGetShopInfo,
    superadminGetUserInfo,
    superadminGetRedisTemplate,
    superadminRedisRefreshTemplate,
    superadminGetDbTemplate,
    superadminClearSourceByType,
    superadminCreateHashListVisualSimilarity,
    PublishType,
    superadminClearDownloadCounter,
    superadminClearRenderCounter,
} from "app/helpers/api";

import toastFactory, { textToast } from "app/helpers/toast_factory";
import { GENERAL_ERROR, GENERAL_SUCCESS } from "template-edit/reducers";
import store from "store";
import { createToast } from "actions";
import { AxiosResponse } from "axios";
import { Project, Template, UserType } from "app/types/model-types";
import { responseToast } from "shape-edit/forms/helpers";
import { iconSize } from "./product-images";
import { URL } from "app/config/api-config";
import Mergado from "app/helpers/mergado";
import { ID } from 'app/types/app-types';
import { find } from 'lodash';

export type ProjectInfoResponseType = {
    mergadoProjectInfo: ProjectInfoType
    dbProjectInfo: Project
    inputFormatSpecification: any
    outputFormatSpecification: any
    mergadoProducts: string[]
    selectedProjectId: number
    selectedTemplateId: number
}

export type TemplateType = {
    id: number
    template: Template
    image: string
    products: number
}

export type TemplateTypes = 'upscaled' | 'bgremoved' | 'wmremoved' | 'rendered' | 'outpainted' | 'inpainted'

export type UserInfoType = {
    id: number
    first_name: string
    last_name: string
    name: string
    username: string
    email: string
    city: string
    company: string
    country: string
    dic: string
    ico: string
    fakturoid_id: number
    invoice_months: number
    last_access: string
    locale: string
    postcode: number
    registered_at: string
    street: string
    timezone: string
    timezone_offset: string
    send_summary: boolean
}

type PermissionsType = {
    role: string
    user_id: number
}

export type ShopInfoType = {
    id: number
    owner_id: number
    tariff_id: number
    tariff_validity: string
    name: string
    web: string
    xml_domain: string
    exported_items: number
    created_at: string
    permissions: PermissionsType[]
}

export type ProjectInfoType = {
    id: number
    shop_id: number
    creator_id: number
    name: string
    url: string
    created: string
    exported_items: number
    input_format: string
    output_format: string
    pairing_elements: string
    readonly: boolean
    is_paused: boolean
    rules_changed_at: string
    is_dirty: boolean
    slug: string
    turned_off: string
    update_period: number
    last_access: string
    xml_synced_at: string
    xml_updated_at: string
    number_of_elements: number
    metadata: any
    all_products_query_id: number
    sync_schedule: {
        minute: string
        hour: string
        day_of_week: string
        day_of_month: string
        month_of_year: string
    }
}

interface Props {
    selectedProjectId: number
    selectedTemplateId: number
    selectedProductId: number
}

interface State {
    projectInfo: ProjectInfoType
    dbProjectInfo: Project
    inputFormatSpecification: any
    outputFormatSpecification: any
    shopInfo: {
        mergadoShopInfo: ShopInfoType
        dbUsers: UserType[]
    }
    creatorInfo: {
        dbUserInfo: UserType
    }
    fillingQueues: boolean
    refreshingRedisTemplate: boolean
    cleaningCache: boolean
    cleaningPNGCache: boolean
    isLoading: boolean
    redisTemplate: Template
    dbTemplate: Template
    isAlt: boolean
}


class ProjectInfo extends Component<Props, State> {
    constructor(props) {
        super(props)

        this.state = {
            isAlt: false,
            isLoading: false,
            projectInfo: null,
            dbProjectInfo: null,
            inputFormatSpecification: null,
            outputFormatSpecification: null,
            shopInfo: null,
            creatorInfo: null,
            fillingQueues: false,
            refreshingRedisTemplate: false,
            cleaningCache: false,
            cleaningPNGCache: false,
            redisTemplate: null,
            dbTemplate: null,
        }
    }

    handleChangeSelectedTemplate = () => {
        const { selectedProjectId, selectedTemplateId } = this.props

        if (selectedTemplateId) {
            superadminGetRedisTemplate(selectedTemplateId)
                .then((response: AxiosResponse<any>) => {
                    this.setState({ redisTemplate: response.data })
                })
                .catch(e => {
                    console.log('cannot get redis template', selectedTemplateId)
                })

            superadminGetDbTemplate(selectedTemplateId)
                .then((response: AxiosResponse<any>) => {
                    this.setState({ dbTemplate: response.data })
                })
                .catch(e => {
                    console.log('cannot get db template', selectedTemplateId)
                })
        }
    }

    getProjectInfo = () => {
        const { selectedProjectId, selectedTemplateId } = this.props
        const { isAlt } = this.state

        this.setState({ isLoading: true })
        superadminGetProjectInfo(selectedProjectId, selectedTemplateId)
            .then((response: AxiosResponse<ProjectInfoResponseType>) => {
                const { shop_id, creator_id } = response.data.mergadoProjectInfo

                this.setState({
                    projectInfo: response.data.mergadoProjectInfo,
                    dbProjectInfo: response.data.dbProjectInfo,
                    outputFormatSpecification: response.data.outputFormatSpecification,
                    inputFormatSpecification: response.data.inputFormatSpecification,
                })

                superadminGetShopInfo(selectedProjectId, shop_id)
                    .then((response: AxiosResponse<any>) => {
                        this.setState({ shopInfo: response.data })
                    })
                    .catch(e => {
                        console.log('error', e)
                    })

                superadminGetUserInfo(selectedProjectId, creator_id)
                    .then((response: AxiosResponse<any>) => {
                        this.setState({ creatorInfo: response.data })
                    })
                    .catch(e => {
                        console.log('error', e)
                    })
            })
            .catch(e => {
                console.error('cannot get project info', e)
            })
            .finally(() => this.setState({ isLoading: false }))
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
        if (prevProps && prevProps.selectedProjectId !== this.props.selectedProjectId && this.props.selectedProjectId) {
            this.getProjectInfo()
        }

        if (prevProps && this.props.selectedTemplateId && prevProps.selectedTemplateId !== this.props.selectedTemplateId) {
            this.handleChangeSelectedTemplate()
        }
    }

    componentDidMount() {
        if (this.props.selectedProjectId) {
            this.getProjectInfo()
        }
    }

    handleFillQueues = (type: PublishType | 'validations', isAlt: boolean, selectedProjectId: number, selectedTemplateId: number, selectedProductsIds: ID[] = []) => {
        this.setState({ fillingQueues: true })
        superadminFillQueues(type, isAlt, selectedProjectId, selectedTemplateId, selectedProductsIds)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(toastFactory(GENERAL_SUCCESS)))
            })
            .catch(error => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, error)))
            })
            .finally(() => {
                this.setState({ fillingQueues: false })
            })
    }

    handleClearDownloadCounter = (isAlt: boolean, selectedProjectId: number, selectedProductsIds: ID[] = []) => {
        superadminClearDownloadCounter(isAlt, selectedProjectId, selectedProductsIds)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(toastFactory(GENERAL_SUCCESS)))
            })
            .catch(error => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, error)))
            })
    }

    handleClearRenderCounter = (isAlt: boolean, selectedProjectId: number, selectedProductsIds: ID[] = []) => {
        superadminClearRenderCounter(isAlt, selectedProjectId, selectedProductsIds)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(toastFactory(GENERAL_SUCCESS)))
            })
            .catch(error => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, error)))
            })
    }


    handleCleanImagesCache = (projectId: number, templateId: number, isAlt: boolean) => {
        this.setState({ cleaningCache: true })
        superadminCleanImagesCache(projectId, templateId, isAlt)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(toastFactory(GENERAL_SUCCESS)))
            })
            .catch(error => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, error)))
            })
            .finally(() => {
                this.setState({ cleaningCache: false })
            })
    }

    handleRefreshRedisTemplate = (projectId: number, templateId: number, isAlt: boolean) => {
        this.setState({ refreshingRedisTemplate: true })
        superadminRedisRefreshTemplate(templateId)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(toastFactory(GENERAL_SUCCESS)))
                this.handleChangeSelectedTemplate()
            })
            .catch(error => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, error)))
            })
            .finally(() => {
                this.setState({ refreshingRedisTemplate: false })
            })
    }

    handleUnlinkTemplatePNGCache = (projectId: number, templateId: number, isAlt: boolean) => {
        this.setState({ cleaningPNGCache: true })
        superadminUnlinkTemplatePNGCache(projectId, templateId)
            .then((response: AxiosResponse<any>) => {
                store.dispatch(createToast(toastFactory(GENERAL_SUCCESS)))
            })
            .catch(error => {
                store.dispatch(createToast(toastFactory(GENERAL_ERROR, error)))
            })
            .finally(() => {
                this.setState({ cleaningPNGCache: false })
            })
    }

    publishSimilarity = (projectId: ID, templateId: ID) => {
        confirm({
            className: 'superadmin-confirm',
            message: <div>
                Create hash list and publish to similarity for template <b>{templateId}</b> project <b>{projectId}</b> ?
            </div>,
            buttons: [
                <Button
                    key={'yes'}
                    type={'void'}
                    size={'small'}
                    secondary={true}
                    color={Theme.green}
                    icon={<Icon type={'check'} text={trans('yes')} />}
                    onClick={() => {
                        superadminCreateHashListVisualSimilarity(projectId, templateId)
                            .then((response: AxiosResponse<any>) => {
                                console.debug(`published project ${projectId} template ${templateId} to visual similarity`, response.data)
                            })
                            .catch(e => console.error('cannot publish to visual similarity', e))
                    }}
                />,
                <Button
                    key={'no'}
                    type={'void'}
                    size={'small'}
                    secondary={true}
                    color={Theme.red}
                    icon={<Icon type={'close'} text={trans('no')} />}
                />,
            ]
        })

    }

    handleClearAll = (type: TemplateTypes, isAlt: boolean, projectId: number, templateId = null) => {
        confirm({
            className: 'superadmin-confirm',
            message: <div>
                Clear all <b>{isAlt ? 'alt' : ''} {type}</b> images for
                {templateId ?
                    <span>template <b>{templateId}</b></span> :
                    <span>project <b>{projectId}</b></span>
                }?
            </div>,
            buttons: [
                <Button
                    key={'yes'}
                    type={'void'}
                    size={'small'}
                    secondary={true}
                    color={Theme.green}
                    icon={<Icon type={'check'} text={trans('yes')} />}
                    onClick={() => {
                        console.debug(`clearing all ${isAlt ? 'alt' : ''} ${type}`, projectId, templateId)
                        superadminClearSourceByType(projectId, templateId, type, isAlt)
                            .then((response: AxiosResponse<any>) => {
                                store.dispatch(createToast(textToast('success', 'hotovo pro typ ' + type)))
                                console.debug(response.data)
                            })
                            .catch(e => {
                                console.error(e)
                            })
                    }}
                />,
                <Button
                    key={'no'}
                    type={'void'}
                    size={'small'}
                    secondary={true}
                    color={Theme.red}
                    icon={<Icon type={'close'} text={trans('no')} />}
                />,
            ]
        })
    }

    render() {
        const { selectedProjectId, selectedTemplateId, selectedProductId } = this.props
        const { isLoading, projectInfo, dbProjectInfo, inputFormatSpecification, outputFormatSpecification,
            fillingQueues,refreshingRedisTemplate, cleaningCache, cleaningPNGCache, creatorInfo, shopInfo, redisTemplate, dbTemplate, isAlt } = this.state

        if (isLoading && !projectInfo) {
            return <StyledProjectInfoGrid>
                <GridCell cols={'1/-1'}>Getting project info <Spinner type={'bubbles'} /></GridCell>
            </StyledProjectInfoGrid>
        }

        if (!projectInfo) {
            return <span />
        }

        const selectedProductsIds = []  //TODO

        const ClearTypes: TemplateTypes[] = ['rendered', 'upscaled', 'bgremoved', 'wmremoved', 'outpainted', 'inpainted']

        let columns = []
        if (shopInfo && shopInfo.mergadoShopInfo && shopInfo.mergadoShopInfo.permissions) {
            shopInfo.mergadoShopInfo.permissions.forEach(permission => {
                const dbUser = shopInfo.dbUsers ? find(shopInfo.dbUsers, (u: UserType) => parseInt(`${permission.user_id}`) === u.id) : null
                columns.push(permission.user_id)
                columns.push(dbUser ? dbUser.name : '')
                columns.push(dbUser ? dbUser.email : '')
                columns.push(permission.role)
            })
        }
        const mappedColumns: any = columns.length > 0 ? columns.map((c, key) => <Cell key={`u${key}`}>{c}</Cell>) : <Cell />

        const ownerDbUser = shopInfo && shopInfo.mergadoShopInfo && shopInfo.dbUsers ? find(shopInfo.dbUsers, (u: UserType) => parseInt(`${shopInfo.mergadoShopInfo.owner_id}`) === u.id) : null
        return (
            <StyledProjectInfoGrid className={isLoading ? 'muk-helper-loading' : ''}>
                <GridCell>
                    <h2>Project info</h2>
                    {projectInfo &&
                        <StyledProjectInfo cols={'min-content auto'} gap={10}>
                            {/* {Object.keys(projectInfo).map(kk => <React.Fragment key={`project_info_${kk}`}>
                                <GridCell className={'name'}>{kk}</GridCell>
                                <GridCell className={'value bold'}>
                                    {kk && kk.startsWith('is_') ?
                                        <Icon type={projectInfo[kk] ? 'toggle-on' : 'toggle-off'} color={projectInfo[kk] ? Theme.red : Theme.grey} size={20} text={projectInfo[kk] ? 'true' : 'false'} /> :
                                        projectInfo[kk]
                                    }
                                </GridCell>
                            </React.Fragment>)} */}

                            <GridCell className={'name'}>name</GridCell><GridCell className={'value bold'}>{projectInfo.name}</GridCell>
                            <GridCell className={'name'}>id</GridCell><GridCell className={'value bold'}>{projectInfo.id}</GridCell>
                            <GridCell className={'name'}>turned off</GridCell><GridCell className={'value bold'}><Icon type={projectInfo.turned_off ? 'toggle-on' : 'toggle-off'} color={projectInfo.turned_off ? Theme.red : Theme.grey} size={20} text={projectInfo.turned_off ? 'true' : 'false'} /></GridCell>
                            <GridCell className={'name'}>is paused</GridCell><GridCell className={'value bold'}><Icon type={projectInfo.is_paused ? 'toggle-on' : 'toggle-off'} color={projectInfo.is_paused ? Theme.red : Theme.grey} size={20} text={projectInfo.is_paused ? 'true' : 'false'} /></GridCell>
                            <GridCell className={'name'}>readonly</GridCell><GridCell className={'value bold'}><Icon type={projectInfo.readonly ? 'toggle-on' : 'toggle-off'} color={projectInfo.readonly ? Theme.orange : Theme.grey} size={20} text={projectInfo.readonly ? 'true' : 'false'} /></GridCell>
                            <GridCell className={'name'}>is dirty</GridCell><GridCell className={'value bold'}><Icon type={projectInfo.is_dirty ? 'toggle-on' : 'toggle-off'} color={projectInfo.is_dirty ? Theme.orange : Theme.grey} size={20} text={projectInfo.is_dirty ? 'true' : 'false'} /></GridCell>
                            <GridCell className={'name'}>created</GridCell><GridCell className={'value'}>{projectInfo.created}</GridCell>
                            <GridCell className={'name'}>creator_id</GridCell><GridCell className={'value bold'}>{projectInfo.creator_id}</GridCell>
                            <GridCell className={'name'}>shop_id</GridCell><GridCell className={'value bold'}>{projectInfo.shop_id}</GridCell>
                            <GridCell className={'name'}>input feed url</GridCell><GridCell className={'value'}><a href={projectInfo.url} target={'_blank'} download>{projectInfo.url}</a></GridCell>
                            <GridCell className={'name'}>output feed url</GridCell><GridCell className={'value'}><a href={`https://feeds.mergado.com/${projectInfo.slug}.${dbProjectInfo?.is_output_csv ? 'csv' : 'xml'}`} target={'_blank'} download>https://feeds.mergado.com/{projectInfo.slug}.{dbProjectInfo?.is_output_csv ? 'csv' : 'xml'}</a></GridCell>
                            <GridCell className={'name'}>exported_items</GridCell><GridCell className={'value'}>{projectInfo.exported_items}</GridCell>
                            <GridCell className={'name'}>format</GridCell><GridCell className={'value bold'}>{projectInfo.input_format} <Icon type={'arrow-right'} /> {projectInfo.output_format}</GridCell>
                            <GridCell className={'name'}>update_period</GridCell><GridCell className={'value'}>{projectInfo.update_period}</GridCell>
                            <GridCell className={'name'}>xml_synced_at</GridCell><GridCell className={'value'}>{projectInfo.xml_synced_at}</GridCell>
                            <GridCell className={'name'}>xml_updated_at</GridCell><GridCell className={'value'}>{projectInfo.xml_updated_at}</GridCell>
                            <GridCell className={'name'}>last_access</GridCell><GridCell className={'value'}>{projectInfo.last_access}</GridCell>
                            <GridCell className={'name'}>sync_schedule</GridCell><GridCell className={'value'}>{JSON.stringify(projectInfo.sync_schedule)}</GridCell>
                            <GridCell className={'name'}>rules_changed_at</GridCell><GridCell className={'value'}>{projectInfo.rules_changed_at}</GridCell>
                            <GridCell className={'name'}>pairing_elements</GridCell><GridCell className={'value bold'}>{projectInfo.pairing_elements}</GridCell>
                            <GridCell className={'name'}>number_of_elements</GridCell><GridCell className={'value'}>{projectInfo.number_of_elements}</GridCell>
                            <GridCell className={'name'}>all_products_query_id</GridCell><GridCell className={'value'}>{projectInfo.all_products_query_id}</GridCell>
                        </StyledProjectInfo>
                    }

                    <h2>Project info db:</h2>
                    {dbProjectInfo &&
                        <StyledProjectInfo cols={'min-content auto'} gap={10}>
                            {Object.keys(dbProjectInfo).filter(k => k.startsWith('e_') || k.startsWith('mergado_') && dbProjectInfo[k]).map(kk => <React.Fragment key={`project_${dbProjectInfo.id}_${kk}`}>
                                <GridCell className={'name'}>{kk}</GridCell><GridCell className={'value bold'}>{dbProjectInfo[kk]}</GridCell>
                            </React.Fragment>
                            )}
                        </StyledProjectInfo>
                    }

                    {projectInfo &&
                        <ButtonsGrid>
                            <Button
                                type={'void'}
                                color={Theme.red}
                                onClick={() => Mergado.openWindow(`https://app.mergado.com/projects/${selectedProjectId}/rules/?do=startApply`)}
                            >Apply rules</Button>
                            <Button
                                disabled={fillingQueues}
                                onClick={() => this.handleFillQueues('downloader', isAlt, selectedProjectId, (selectedTemplateId || null), selectedProductsIds)}
                                type={'void'}
                                color={Theme.green}
                                icon={fillingQueues ? <Spinner /> : ''}
                            >Fill refresh images</Button>
                            <Button
                                disabled={fillingQueues}
                                onClick={() => this.handleFillQueues('composer', isAlt, selectedProjectId, (selectedTemplateId || null), selectedProductsIds)}
                                type={'void'}
                                color={Theme.orange}
                                icon={fillingQueues ? <Spinner /> : ''}
                            >Fill compose images</Button>
                            <Button
                                disabled={fillingQueues}
                                onClick={() => this.handleFillQueues('validations', isAlt, selectedProjectId, (selectedTemplateId || null), selectedProductsIds)}
                                type={'void'}
                                color={Theme.blue}
                                icon={fillingQueues ? <Spinner /> : ''}
                            >Fill validations images</Button>
                            <Button
                                disabled={fillingQueues}
                                onClick={() => this.handleFillQueues('autowmremover', isAlt, selectedProjectId, (selectedTemplateId || null), selectedProductsIds)}
                                type={'void'}
                                color={Theme.grey}
                                icon={fillingQueues ? <Spinner /> : ''}
                            >Fill watermark removal</Button>
                            <Button
                                disabled={fillingQueues}
                                onClick={() => this.handleFillQueues('inpainter', isAlt, selectedProjectId, (selectedTemplateId || null), selectedProductsIds)}
                                type={'void'}
                                color={Theme.grey}
                                icon={fillingQueues ? <Spinner /> : ''}
                            >Fill inpainter</Button>
                            <Button
                                disabled={fillingQueues}
                                onClick={() => this.handleFillQueues('bgremover', isAlt, selectedProjectId, (selectedTemplateId || null), selectedProductsIds)}
                                type={'void'}
                                color={Theme.steelblue}
                                icon={fillingQueues ? <Spinner /> : ''}
                            >Fill background removal</Button>
                            <Button
                                type={'void'}
                                color={Theme.orange}
                                onClick={() => this.handleClearDownloadCounter(isAlt, selectedProjectId, selectedProductsIds)}
                            >Clear download counter</Button>
                            <Button
                                type={'void'}
                                color={Theme.orange}
                                onClick={() => this.handleClearRenderCounter(isAlt, selectedProjectId, selectedProductsIds)}
                            >Clear render counter</Button>
                            {selectedTemplateId &&
                                <Button
                                    disabled={fillingQueues}
                                    onClick={() => this.handleFillQueues('upscaler', isAlt, selectedProjectId, (selectedTemplateId || null), selectedProductsIds)}
                                    type={'void'}
                                    color={Theme.grey}
                                    icon={fillingQueues ? <Spinner /> : ''}
                                >Fill upscale queues for {selectedTemplateId}</Button>
                            }

                            {ClearTypes.map(type => <Button
                                key={`clear${type}`}
                                secondary={true}
                                onClick={() => this.handleClearAll(type, false, selectedProjectId, selectedTemplateId)}
                                type={'void'}
                                icon={<Icon type={'trash'} size={iconSize} color={Theme.red} text={`${type} ${(type === 'rendered' && selectedTemplateId) ? `[${selectedTemplateId}]` : ''} ${selectedProjectId ? `(${selectedProjectId})` : ''}`} />}
                            />)}

                            {ClearTypes.map(type => <Button
                                key={`clear${type}`}
                                secondary={true}
                                onClick={() => this.handleClearAll(type, true, selectedProjectId, selectedTemplateId)}
                                type={'void'}
                                icon={<Icon type={'trash'} size={iconSize} color={Theme.red} text={`ALT ${type} ${(type === 'rendered' && selectedTemplateId) ? `[${selectedTemplateId}]` : ''} ${selectedProjectId ? `(${selectedProjectId})` : ''}`} />}
                            />)}

                            <Button
                                type={'void'}
                                secondary={true}
                                disabled={!selectedTemplateId}
                                color={Theme.green}
                                onClick={() => this.publishSimilarity(selectedProjectId, selectedTemplateId)}
                            >create hash list ({selectedProjectId},{selectedTemplateId}) similarity</Button>
                        </ButtonsGrid>
                    }
                </GridCell>

                <GridCell>
                    {shopInfo &&
                        <div className={'shop-info'}>
                            <h2>Shop info</h2>
                            {shopInfo.mergadoShopInfo &&
                                <StyledProjectInfo cols={'min-content auto'} gap={10}>
                                    <GridCell className={'name'}>name:</GridCell><GridCell className={'value bold'}>{shopInfo.mergadoShopInfo.name}</GridCell>
                                    <GridCell className={'name'}>owner_id:</GridCell><GridCell className={'value'}>
                                        {shopInfo.mergadoShopInfo.owner_id}
                                        {ownerDbUser &&
                                            <span> {ownerDbUser.name} ({ownerDbUser.email})</span>
                                        }
                                    </GridCell>
                                    <GridCell className={'name'}>allowed users:</GridCell><GridCell className={'value'}>

                                        {mappedColumns && mappedColumns.length > 0 &&
                                            <Table header={[
                                                "user_id",
                                                "name",
                                                "email",
                                                "role",
                                            ]}>
                                                {mappedColumns}
                                            </Table>
                                        }

                                    </GridCell>
                                </StyledProjectInfo>
                            }

                        </div>
                    }

                    {creatorInfo &&
                        <div className={'user-info'}>
                            <h2>Creator info</h2>
                            {creatorInfo.dbUserInfo &&
                                <StyledProjectInfo cols={'min-content auto'} gap={10}>
                                    <GridCell className={'name'}>user id:</GridCell><GridCell className={'value'}>{creatorInfo.dbUserInfo.id}</GridCell>
                                    <GridCell className={'name'}>user name:</GridCell><GridCell className={'value bold'}>{creatorInfo.dbUserInfo.name}</GridCell>
                                    <GridCell className={'name'}>e-mail:</GridCell><GridCell className={'value bold'}>{creatorInfo.dbUserInfo.email}</GridCell>
                                    <GridCell className={'name'}>user locale:</GridCell><GridCell className={'value bold'}>{creatorInfo.dbUserInfo.locale}</GridCell>
                                    <GridCell className={'name'}>show news-box:</GridCell><GridCell className={'value'}>{creatorInfo.dbUserInfo.show_newsbox ? '1' : '0'}</GridCell>
                                </StyledProjectInfo>
                            }

                            {selectedTemplateId &&
                                <Grid cols={'auto auto'}>
                                    {redisTemplate && redisTemplate.id &&
                                        <GridCell>
                                            <h3>redis template {redisTemplate.id}</h3>
                                            <div>redis template type {redisTemplate.type}</div>

                                            {redisTemplate.effect_sensitivity &&
                                                <div>effect_sensitivity: {redisTemplate.effect_sensitivity}</div>
                                            }
                                            <div>updated_at: {redisTemplate.updated_at}</div>
                                            <div>
                                                {redisTemplate.shapes &&
                                                    <ul>
                                                        {redisTemplate.shapes.map(shape => <li key={shape.index}>
                                                            <span>{shape.priority}. {shape.type}: {shape.name} </span>
                                                            {shape.text_xml_element && shape.text_xml_element}
                                                            {shape.image_xml_element && shape.image_xml_element}
                                                            {shape.rating_xml_element && shape.rating_xml_element}
                                                            {shape.rating_count_xml_element && shape.rating_count_xml_element}
                                                            {shape.rating_from_depots && shape.rating_from_depots}

                                                            {shape.width && shape.height &&
                                                                <span> {shape.width}x{shape.height}</span>
                                                            }

                                                            {shape.text_content &&
                                                                <span> {shape.text_content}</span>
                                                            }
                                                            {shape.is_hidden &&
                                                                <span> (hidden)</span>
                                                            }
                                                        </li>)}
                                                    </ul>
                                                }
                                            </div>
                                        </GridCell>
                                    }

                                    <GridCell>
                                        <a href={`${URL.laravelBase}reports/get-template-png/${selectedTemplateId}`} target="_blank">
                                            <img
                                                src={`${URL.laravelBase}reports/get-template-png/${selectedTemplateId}`}
                                                className="shadow-box checker template-image"
                                                style={{ maxWidth: '300px', maxHeight: '300px' }}
                                            />
                                        </a>
                                    </GridCell>

                                    {dbTemplate && dbTemplate.id &&
                                        <GridCell>
                                            <h3>db template {dbTemplate.id}</h3>
                                            <div>db template type { dbTemplate.type}</div>

                                            {dbTemplate.effect_sensitivity &&
                                                <div>effect_sensitivity: {dbTemplate.effect_sensitivity}</div>
                                            }
                                            <div>updated_at: {dbTemplate.updated_at}</div>

                                            <div>
                                                {dbTemplate.shapes &&
                                                    <ul>
                                                        {dbTemplate.shapes.map(shape => <li key={shape.index}>
                                                            <span>{shape.priority}. {shape.type}: {shape.name} </span>
                                                            {shape.text_xml_element && shape.text_xml_element}
                                                            {shape.image_xml_element && shape.image_xml_element}
                                                            {shape.rating_xml_element && shape.rating_xml_element}
                                                            {shape.rating_count_xml_element && shape.rating_count_xml_element}

                                                            {shape.width && shape.height &&
                                                                <span> {shape.width}x{shape.height}</span>
                                                            }

                                                            {shape.text_content &&
                                                                <span> {shape.text_content}</span>
                                                            }
                                                            {shape.is_hidden &&
                                                                <span> (hidden)</span>
                                                            }
                                                        </li>)}
                                                    </ul>
                                                }
                                            </div>
                                        </GridCell>
                                    }
                                    <GridCell>
                                        <Grid cols={'auto'} gap={'10px'}>
                                            <Button
                                                disabled={cleaningCache}
                                                onClick={() => this.handleRefreshRedisTemplate(selectedProjectId, selectedTemplateId, isAlt)}
                                                type={'void'}
                                                color={Theme.blue}
                                                icon={refreshingRedisTemplate ? <Spinner /> : ''}
                                            >Refresh redis template ({selectedTemplateId})</Button>
                                            <Button
                                                disabled={cleaningPNGCache}
                                                onClick={() => this.handleUnlinkTemplatePNGCache(selectedProjectId, selectedTemplateId, isAlt)}
                                                type={'void'}
                                                color={Theme.orange}
                                                icon={cleaningPNGCache ? <Spinner /> : ''}
                                            >Unlink template PNG ({selectedTemplateId})</Button>
                                            <Button
                                                disabled={cleaningCache}
                                                onClick={() => this.handleCleanImagesCache(selectedProjectId, selectedTemplateId, isAlt)}
                                                type={'void'}
                                                color={Theme.orange}
                                                icon={cleaningCache ? <Spinner /> : ''}
                                            >Clean rendered folder ({selectedTemplateId})</Button>
                                        </Grid>
                                    </GridCell>
                                </Grid>
                            }

                        </div>
                    }
                </GridCell>

                {inputFormatSpecification &&
                    <GridCell>
                        <h3>input ({dbProjectInfo?.input_format})</h3>
                        <div style={{ height: '200px', overflow: 'auto' }}>
                            <code>{JSON.stringify(inputFormatSpecification, null, "  ")}</code>
                        </div>
                    </GridCell>
                }

                {outputFormatSpecification &&
                    <GridCell>
                        <h3>output ({dbProjectInfo?.output_format})</h3>
                        <div style={{ height: '200px', overflow: 'auto' }}>
                            <code>{JSON.stringify(outputFormatSpecification, null, "  ")}</code>
                        </div>
                    </GridCell>
                }
            </StyledProjectInfoGrid>
        )
    }
}

const StyledProjectInfo = css(Grid)({
    overflow: 'auto',
    marginBottom: '30px',
    ' .name': {
        textAlign: 'right',
        whiteSpace: 'nowrap',
    },
    ' .bold': {
        fontWeight: 'bold',
    },
})

const StyledProjectInfoGrid = css(Grid)({
    gridTemplateColumns: 'repeat(2, 1fr)',
    '@media screen and (max-width: 1024px)': {
        gridTemplateColumns: 'auto',
    },
    marginBottom: '60px',
    minHeight: 'calc(100vh - 200px)',
})

const ButtonsGrid = css(Grid)({
    padding: '10px',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
    gridGap: '5px',
    '@media screen and (max-width: 1024px)': {
        gridTemplateColumns: 'auto',
    },
})

export default ProjectInfo